import { Popover } from 'antd';
import Icon, { InfoIcon } from 'components/Atoms/Icon';
import React from 'react';
import cn from 'classnames';

import './styles.scss';

const InformationPopover = ({
  overClayClassName = '',
  childClassName = '',
  ...restProps
}) => {
  return (
    <Popover
      overlayClassName={cn('info-popover', overClayClassName)}
      {...restProps}
    >
      <span className={cn('popover-child', childClassName)}>
        <Icon className="" component={InfoIcon} />
      </span>
    </Popover>
  );
};

export default InformationPopover;
